import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = ''
}: ButtonProps) {
  return <motion.a href="https://comerfacil.shop/cart/44790229336179:1" className={`inline-block bg-brand-orange hover:bg-brand-yellow text-white font-poppins font-bold text-lg md:text-2xl py-4 px-8 rounded-full shadow-[0_10px_20px_rgba(232,133,58,0.4)] transition-colors text-center w-full max-w-md mx-auto ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(232,133,58,0.4)', '0px 0px 20px 10px rgba(232,133,58,0.2)', '0px 0px 0px 0px rgba(232,133,58,0.4)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity
    }
  }} data-id="element-28">
      {children}
    </motion.a>;
}